import { combineReducers } from "redux";
import errorReducer from "./ErrorResponse/Reducer";
import renewalReducer from "./PolicyNumber/reducer";
import { belstarReducer, belstarAvailable } from "./PolicyNumber/belstar-reducer";

// add reducers here
const rootReducer = combineReducers({
    policyDetails: renewalReducer,
    belstarDetails: belstarReducer,
    belstarAvailable: belstarAvailable,
    error: errorReducer,
});

export default rootReducer;
